<script>
export default {
  name: "IgModal",
  props: {
    active: {
      type: Boolean,
      default: true
    },
    isCard: {
      default: false
    },
    title: {
      default: null
    }
  },
  mounted() {
    this.chkScroll();
    window.addEventListener("keydown", this.evtKey);
  },
  watch: {
    active(n, o) {
      this.chkScroll();
    }
  },
  beforeDestroy() {
    document.documentElement.style.overflow = "auto";
    window.removeEventListener("keydown", this.evtKey);
  },
  methods: {
    evtKey(e) {
      if (e.key == "Escape") {
        this.$emit("close");
      }
    },
    chkScroll() {
      if (this.active) document.documentElement.style.overflow = "hidden";
      else document.documentElement.style.overflow = "auto";
    },
    clkClose() {
      this.$emit("close");
    }
  }
};
</script>
<template>
  <div class="modal" :class="active ? 'is-active' : ''">
    <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-card" v-if="isCard">
      <header class="modal-card-head">
        <p class="modal-card-title" v-if="title">{{ title }}</p>
        <button
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        ></button>
      </header>
      <section class="modal-card-body px-0">
        <slot> </slot>
      </section>
      <footer class="modal-card-foot">
        <slot name="footer"> </slot>
        <!-- <button class="button is-success">Save changes</button>
        <button class="button">Cancel</button> -->
      </footer>
    </div>
    <template v-else>
      <div class="modal-content has-background-white">
        <div class="ghdr2" v-if="title">
          {{title}}
        </div>
        <slot> </slot>
        <slot name="footer">
          <div class="mt-1">
            <b-button icon-left="times" @click="clkClose">{{
              $t("g.close")
            }}</b-button>
          </div>
        </slot>
      </div>



      <button
        class="modal-close is-large"
        aria-label="close"
        @click="$emit('close')"
      ></button>
    </template>
  </div>
</template>
